import { Typography } from "@mui/material";

export const WrappedColumnHeader = ({ label }: { label: string }) => (
  <Typography variant="caption" sx={{ whiteSpace: "normal" }}>
    {label}
  </Typography>
);
